module.exports = __webpack_public_path__ + "img/right-arrow-black.12fabcca.svg";